import { Widget, WIDGET_LIVETABLE } from "@gaming/srvg-classes-core";


export class LivetableLeagueWidget extends Widget {
    widgetName: string;
    widget: any;

    constructor( options ) {
        options = options || {};
        options.selector = options.selector || "#livetableWidget";
        super( options );

        this.name = "widgetlivetable";
        this.widgetName = options.widgetName || WIDGET_LIVETABLE;
        this.widgetName = this.product + this.widgetName;

        this.widget = null;

        this.widgetOptions = {
            height: this.getContainerHeightWithUnit(),
            showHeader: false
        };

        this.mergeWidgetOptions(options);
    }

    handleDomInstantiated() {
        this.addLivetableWidget();
        super.handleDomInstantiated();
    }

    /**
     * add livetable widget to given selector (html element selector)
     * @param string selector html element selected (not element itself)
     */
    addLivetableWidget(selector?) {
        var that = this;
        selector = selector || this.selector;

        this.widget = this.addWidget(
            selector,
            this.widgetName,
            this.widgetOptions
        );
    }

    /**
     * add specific widget will be called by events for example, prepares eventdata and calls addLivetableWidget
     * @param string selector
     * @param object/any eventdata
     */
    addSpecificWidget(element, eventdata){
        this.addLivetableWidget(element);
    }
}
